import React from "react";

function DoesNotExist() {
  return <div>DoesNotExist</div>;
}

export default DoesNotExist;
